import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { useIcon } from "../../../hooks/useIcon/index.mjs";
import { IconCogSvg } from "./IconCogSvg.mjs";
const IconCog = (props) => {
  const iconProps = useIcon(props);
  return /* @__PURE__ */ jsx(Box, { component: IconCogSvg, ...iconProps });
};
export {
  IconCog
};
